import { useState, useEffect } from 'react';
import { EnvUtil } from '@aperza/util';
let key = 'AIzaSyAuwdMg7BWqk6FXmYAMm3OGGJIrbFSkvxU';
const env = EnvUtil.getAppEnv();
if (env === EnvUtil.ENV_TEST || env === EnvUtil.ENV_STORYBOOK) {
    key = 'AIzaSyA5qRKXMuT7sL-Ho5dTgtj44G2dGROy6ho';
}
else if (env === EnvUtil.ENV_TEST_2) {
    key = 'AIzaSyA5qRKXMuT7sL-Ho5dTgtj44G2dGROy6ho';
}
else if (env === EnvUtil.ENV_STG) {
    key = 'AIzaSyAknYVSYzz3IGZ22AX_9_hBgkuffGJtyww';
}
else if (env === EnvUtil.ENV_PROD) {
    key = 'AIzaSyAuwdMg7BWqk6FXmYAMm3OGGJIrbFSkvxU';
}
export const useYouTubeInfo = (videoId) => {
    const [video, setVideo] = useState({});
    const [loadingVideoInfo, setLoadingVideoInfo] = useState(false);
    const loadVideoInfo = (_videoId) => {
        if (_videoId === undefined || _videoId === null || _videoId.length === 0)
            return;
        const outputPart = 'snippet,statistics';
        const url = `https://www.googleapis.com/youtube/v3/videos?key=${key}&id=${_videoId}&part=${outputPart}`;
        setLoadingVideoInfo(true);
        return fetch(url)
            .then(function (response) {
            if (response.status >= 400) {
                throw new Error('Bad response from server');
            }
            setLoadingVideoInfo(false);
            return response.json();
        })
            .then(function (data) {
            if (Array.isArray(data.items) && data.items.length > 0) {
                const item = data.items[0];
                setVideo({
                    videoId: item.id,
                    title: item.snippet.title,
                    thumbnailUrl: item.snippet.thumbnails.default.url,
                    authorName: item.snippet.channelTitle,
                    viewCount: item.statistics.viewCount,
                    publishedAt: item.snippet.publishedAt,
                    tags: item.snippet.tags,
                    videoUrl: `https://www.youtube.com/embed/${_videoId}?&autoplay=1&rel=0`,
                });
            }
            setLoadingVideoInfo(false);
        })
            .catch((error) => {
            console.error(error);
            setLoadingVideoInfo(false);
        });
    };
    useEffect(() => {
        loadVideoInfo(videoId);
    }, [videoId]);
    return {
        video,
        loadingVideoInfo,
        setVideoId: (_videoId) => loadVideoInfo(_videoId),
    };
};
